module.exports = __webpack_public_path__ + "static/media/128-raw-fit-mobile.7f718fff.svg";